// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2CRTT","additionalInfo":"AgreementModal_additionalInfo__2Tf3b"};